export const iconFontAwesomeBuildingsHouseMedicalCircleCheck = (
	<i className="fa-solid fa-house-medical-circle-check"></i>
);
